import { logError } from "./logging";
export function exhaustiveSwitchWithDefault(defaultValue, _unhandled) {
    return function(switchValue) {
        logError(new Error("Received unexpected value inside exhaustive switch"), {
            data: {
                defaultValue: defaultValue,
                unexpectedValue: switchValue
            }
        });
        return defaultValue;
    };
}
